import {PayloadAction} from "../payload-action.interface";
import {TemplateEntity} from "./template.entity";


export class TemplateActions{
  static readonly ADD 		  = '[TemplateActions] ADD';
  static readonly ADD_ALL 	= '[TemplateActions] ADD_ALL';
  static readonly REMOVE 		= '[TemplateActions] REMOVE';
  static readonly SET 		  = '[TemplateActions] SET';

  static addAll(templates: Array<TemplateEntity>): PayloadAction{
    return {
      type: TemplateActions.ADD_ALL,
      payload: templates
    }
  }

  static add(template: TemplateEntity): PayloadAction{
    return {
      type: TemplateActions.ADD,
      payload: template
    }
  }

  static set(template: TemplateEntity): PayloadAction{

    return {
      type: TemplateActions.SET,
      payload: template
    }
  }

  static remove(id: string): PayloadAction{
    return {
      type: TemplateActions.REMOVE,
      payload: id
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/template/template.actions.ts